<template lang='pug'>
div
  slot(
    :foodAddFavorite='foodAddFavorite'
    :foodCreateV2='foodCreateV2'
    :foodEntriesCopy='foodEntriesCopy'
    :foodEntriesCopySavedMeal='foodEntriesCopySavedMeal'
    :foodEntriesGet='foodEntriesGet'
    :foodEntriesGetMonth='foodEntriesGetMonth'
    :foodEntryCreate='foodEntryCreate'
    :foodEntryDelete='foodEntryDelete'
    :foodEntryEdit='foodEntryEdit'
    :foodFindIdForBarcode='foodFindIdForBarcode'
    :foodGetV2='foodGetV2'
    :foodsAutocomplete='foodsAutocomplete'
    :foodsGetFavorites='foodsGetFavorites'
    :foodsGetMostEaten='foodsGetMostEaten'
    :foodsGetRecentlyEaten='foodsGetRecentlyEaten'
    :foodsSearch='foodsSearch'
    :profileGet='profileGet'
    :savedMealCreate='savedMealCreate'
    :savedMealDelete='savedMealDelete'
    :savedMealItemAdd='savedMealItemAdd'
    :savedMealItemsGet='savedMealItemsGet'
    :savedMealsGet='savedMealsGet'
    :weightsGetMonth='weightsGetMonth'
    :weightUpdate='weightUpdate'
  )
</template>

<script>
import {
  foodAddFavorite,
  foodCreateV2,
  foodEntriesCopy,
  foodEntriesCopySavedMeal,
  foodEntriesGet,
  foodEntriesGetMonth,
  foodEntryCreate,
  foodEntryDelete,
  foodEntryEdit,
  foodFindIdForBarcode,
  foodGetV2,
  foodsAutocomplete,
  foodsGetFavorites,
  foodsGetMostEaten,
  foodsGetRecentlyEaten,
  foodsSearch,
  profileGet,
  savedMealCreate,
  savedMealDelete,
  savedMealItemAdd,
  savedMealItemsGet,
  savedMealsGet,
  weightsGetMonth,
  weightUpdate,
} from '../functions/postDelegatedRequest';

export default
{
  methods:
  {
    foodAddFavorite,
    foodCreateV2,
    foodEntriesCopy,
    foodEntriesCopySavedMeal,
    foodEntriesGet,
    foodEntriesGetMonth,
    foodEntryCreate,
    foodEntryDelete,
    foodEntryEdit,
    foodFindIdForBarcode,
    foodGetV2,
    foodsAutocomplete,
    foodsGetFavorites,
    foodsGetMostEaten,
    foodsGetRecentlyEaten,
    foodsSearch,
    profileGet,
    savedMealCreate,
    savedMealDelete,
    savedMealItemAdd,
    savedMealItemsGet,
    savedMealsGet,
    weightsGetMonth,
    weightUpdate,
  }
};
</script>